module.exports = {
    "Clear search": `\u{6E05}\u{9664}\u{641C}\u{7D22}`
};


//# sourceMappingURL=zh-CN.main.js.map
